import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import SelectionBoxElement from './SelectionBoxElement';

const SelectionBoxStyle = styled.div`
  width: 100%;
`;

const SelectionBox = (props) => {
  return (
    <SelectionBoxStyle>
      {(props.data.map((obj) => 
        <SelectionBoxElement 
          className={props.className}
          key={obj.id}
          width={props.width}
          mobileWidth={props.mobileWidth}
          height={props.height}
          borderRadius={props.borderRadius}
          borderWidth={props.borderWidth}
          borderColor={props.borderColor}
          activeColor={props.activeColor}
          textColor={props.textColor}
          fontSize={props.fontSize}
          marginRight={props.marginRight}
          marginBottom={props.marginBottom}
          mobileMarginRight={props.mobileMarginRight}
          mobileMarginBottom={props.mobileMarginBottom}
          active={(obj.id === props.activeElementId) ? true  : false }
          onClick={(event) => props.handleSelect(obj.id, event)}
        >{obj.label}</SelectionBoxElement> 
      ))}
    </SelectionBoxStyle>
  );
}

SelectionBox.propTypes = {
  data: PropTypes.array,
  activeElementId: PropTypes.number,
  handleSelect: PropTypes.func
};

SelectionBox.defaultProps = {
  data: [],
  activeElementId: 1
};

export default SelectionBox;


// WEBPACK FOOTER //
// ./src/components/UI/SelectionBox/SelectionBox.js